import { useTranslation } from 'react-i18next';
import { IntegrationSettings } from '@anticatrade/shared';
import SlInput from '@shoelace-style/shoelace/dist/react/input/index.js';
import type { IntegrationSettingsFormProps } from './integrationForms';
import { WebsiteSettings } from './Website';

const hasRequiredWoocommerceSettings = (settings: IntegrationSettings): boolean =>
	!!settings.websiteURL?.trim() &&
	!!settings.consumerKey?.trim() &&
	!!settings.consumerSecret?.trim();

const WoocommerceSettings = ({ settings, onChange }: IntegrationSettingsFormProps) => {
	const { t } = useTranslation();

	return (
		<div className='integration__settings'>
			<SlInput
				label={t('Website URL')}
				placeholder='https://www.example.com'
				value={settings.websiteURL ?? ''}
				onSlInput={(e: any) => onChange({ ...settings, websiteURL: e.target.value })}
				required
			/>
			<SlInput
				label={t('Consumer key')}
				value={settings.consumerKey ?? ''}
				onSlInput={(e: any) => onChange({ ...settings, consumerKey: e.target.value })}
				required
			/>
			<SlInput
				label={t('Consumer secret')}
				type='password'
				password-toggle
				value={settings.consumerSecret ?? ''}
				onSlInput={(e: any) => onChange({ ...settings, consumerSecret: e.target.value })}
				required
			/>
			<WebsiteSettings settings={settings} onChange={onChange} />
		</div>
	);
};

export { WoocommerceSettings, hasRequiredWoocommerceSettings };
